"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrackingChecklistPublicNetworksT = exports.TrackingChecklistPublicNetworks = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
class TrackingChecklistPublicNetworks {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsTrackingChecklistPublicNetworks(bb, obj) {
        return (obj || new TrackingChecklistPublicNetworks()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsTrackingChecklistPublicNetworks(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new TrackingChecklistPublicNetworks()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    adapters(index, optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? this.bb.__string(this.bb.__vector(this.bb_pos + offset) + index * 4, optionalEncoding) : null;
    }
    adaptersLength() {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
    }
    static startTrackingChecklistPublicNetworks(builder) {
        builder.startObject(1);
    }
    static addAdapters(builder, adaptersOffset) {
        builder.addFieldOffset(0, adaptersOffset, 0);
    }
    static createAdaptersVector(builder, data) {
        builder.startVector(4, data.length, 4);
        for (let i = data.length - 1; i >= 0; i--) {
            builder.addOffset(data[i]);
        }
        return builder.endVector();
    }
    static startAdaptersVector(builder, numElems) {
        builder.startVector(4, numElems, 4);
    }
    static endTrackingChecklistPublicNetworks(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createTrackingChecklistPublicNetworks(builder, adaptersOffset) {
        TrackingChecklistPublicNetworks.startTrackingChecklistPublicNetworks(builder);
        TrackingChecklistPublicNetworks.addAdapters(builder, adaptersOffset);
        return TrackingChecklistPublicNetworks.endTrackingChecklistPublicNetworks(builder);
    }
    unpack() {
        return new TrackingChecklistPublicNetworksT(this.bb.createScalarList(this.adapters.bind(this), this.adaptersLength()));
    }
    unpackTo(_o) {
        _o.adapters = this.bb.createScalarList(this.adapters.bind(this), this.adaptersLength());
    }
}
exports.TrackingChecklistPublicNetworks = TrackingChecklistPublicNetworks;
class TrackingChecklistPublicNetworksT {
    constructor(adapters = []) {
        this.adapters = adapters;
    }
    pack(builder) {
        const adapters = TrackingChecklistPublicNetworks.createAdaptersVector(builder, builder.createObjectOffsetList(this.adapters));
        return TrackingChecklistPublicNetworks.createTrackingChecklistPublicNetworks(builder, adapters);
    }
}
exports.TrackingChecklistPublicNetworksT = TrackingChecklistPublicNetworksT;
